// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"fd1c4511","192":"c9c21c29","309":"b91c5fd1","453":"d888fdb1","456":"bdc6d858","576":"7bd24e8e","692":"a2f23690","851":"953252e6","928":"e500fccf","981":"99ad920b","984":"f84e0377","992":"24598201"}[chunkId] + ".chunk.js";
};